(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaSsoLog', RcopiaSsoLog);

    RcopiaSsoLog.$inject = ['$resource', 'DataUtils'];

    function RcopiaSsoLog ($resource, DataUtils) {
        var resourceUrl =  'api/rcopia-sso-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-sso-logs/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'payload': {
                url: 'api/rcopia-sso-logs/payload/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'payloadStr': {
                url: 'api/rcopia-sso-logs/payload/str/:id',
                method: 'GET',
                transformResponse: function (data) {
                    return {data: data};
                }
            },
            'response': {
                url: 'api/rcopia-sso-logs/response/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'responseStr': {
                url: 'api/rcopia-sso-logs/response/str/:id',
                method: 'GET',
                transformResponse: function (data) {
                    return {data: data};
                }
            },
        });
    }
})();
